<template>
    <div class="services-details-area ptb-100">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-12">
                    <div class="services-details-image">
                        <img src="../../assets/images/services/full-mouth-rehab/full_mouth_bg.webp" alt="image">
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('full_mouth_rehab_title') }}</h3></u>
                        <p>{{ $t('full_mouth_rehab_p') }}</p>
                    </div>
                    <div class="services-details-content">
                        <u><h3>{{ $t('full_mouth_rehab_page_indication_title') }}</h3></u>
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <ul class="services-details-list">
                                    <li>
                                    <i class="flaticon-check"></i>
                                    
                                    {{ $t('full_mouth_rehab_page_indication_1') }}
                                </li>
    
                                <li>
                                    <i class="flaticon-check"></i>
                                    {{ $t('full_mouth_rehab_page_indication_2') }}
                                </li>
                                <li>
                                    <i class="flaticon-check"></i>
                                    {{ $t('full_mouth_rehab_page_indication_3') }}
                                </li>
                                </ul>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <ul class="services-details-list">
                                    <li>
                                        <i class="flaticon-check"></i>
                                        {{ $t('full_mouth_rehab_page_indication_4') }}
                                    </li>
    
                                
                                    <li>
                                        <i class="flaticon-check"></i>
                                        {{ $t('full_mouth_rehab_page_indication_5') }}
                                    </li>
                   
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('full_mouth_rehab_advantages_title') }}</h3></u>
                        <p >{{ $t('full_mouth_rehab_advantages_p') }}</p>
                        
                    </div>

                    <div class="services-details-overview">
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <div class="single-gallery">
                                    <img src="../../assets/images/services/full-mouth-rehab/clients/full_mouth1.webp" alt="image">
                                </div>
                            </div>
        
                            <div class="col-lg-6 col-md-6">
                                <div class="single-gallery">
                                    <img src="../../assets/images/services/full-mouth-rehab/clients/fullmouth_one.webp" alt="image">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('full_mouth_rehab_page_stages_title') }}</h3></u>
                        <ol>
                                <li>
                                    <b>{{ $t('full_mouth_rehab_page_stages_examination_bold') }}</b>
                                    <ul>
                                        <li>{{ $t('full_mouth_rehab_page_stages_examination') }}</li>
                                        <li>{{ $t('full_mouth_rehab_page_stages_examination1') }}</li>
                                    </ul>
                                </li>
                                <li>
                                    <b>{{ $t('full_mouth_rehab_page_stages_treatment_bold') }}</b> 
                                    <ul>
                                        <li>{{ $t('full_mouth_rehab_page_stages_treatment') }}</li>
                                    </ul>
                                </li>

                                <li>
                                    <b>{{ $t('full_mouth_rehab_page_stages_disease_bold') }}</b> 
                                    <ul>
                                        <li>{{ $t('full_mouth_rehab_page_stages_disease') }}</li>
                                    </ul>
                                </li>
                                <li>
                                    <b>{{ $t('full_mouth_rehab_page_stages_restorative_bold') }}</b> 
                                    <ul>
                                        <li>{{ $t('full_mouth_rehab_page_stages_restorative') }}</li>
                                        <li>{{ $t('full_mouth_rehab_page_stages_restorative1') }}</li>
                                    </ul>
                                </li>

                                <li>
                                    <b>{{ $t('full_mouth_rehab_page_stages_orthodontic_bold') }}</b> 
                                    <ul>
                                        <li>{{ $t('full_mouth_rehab_page_stages_orthodontic') }}</li>
                                    </ul>
                                </li>
                               

                                <li>
                                    <b>{{ $t('full_mouth_rehab_page_stages_temporomandibular_bold') }}</b>
                                    <ul>
                                        <li>{{ $t('full_mouth_rehab_page_stages_temporomandibular') }}</li>
                                    </ul>
                                </li>
                                <li>
                                    <b>{{ $t('full_mouth_rehab_page_stages_cosmetic_bold') }}</b>
                                    <ul>
                                        <li>{{ $t('full_mouth_rehab_page_stages_cosmetic') }}</li>
                                    </ul>
                                </li>
                                <li>
                                    <b>{{ $t('full_mouth_rehab_page_stages_restorations_bold') }}</b>
                                    <ul>
                                        <li>{{ $t('full_mouth_rehab_page_stages_restorations') }}</li>
                                    </ul>
                                </li>
                                <li>
                                    <b>{{ $t('full_mouth_rehab_page_stages_finalization_bold') }}</b>
                                    <ul>
                                        <li>{{ $t('full_mouth_rehab_page_stages_finalization') }}</li>
                                        <li>{{ $t('full_mouth_rehab_page_stages_finalization1') }}</li>
                                    </ul>
                                </li>
                                <li>
                                    <b>{{ $t('full_mouth_rehab_page_stages_maintenance_bold') }}</b>
                                    <ul>
                                        <li>{{ $t('full_mouth_rehab_page_stages_maintenance') }}</li>
                                        <li>{{ $t('full_mouth_rehab_page_stages_maintenance1') }}</li>
                                    </ul>
                                </li>
                            </ol> 
                    </div>


                    
                </div>

                <div class="sidebar-container col-md-4 col-sm-12">
                    <div class="sidebar-wrapper" ref="sidebar">
                        <BlogSidebarFullMouthRest />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BlogSidebarFullMouthRest from '../../components/services-sidebars/BlogSidebarFullMouthRest.vue';

export default {
    name: 'FullMouthRehab',
    components: {
        BlogSidebarFullMouthRest
    },
    mounted() {
    // Get the sidebar element
    const sidebar = this.$refs.sidebar;

    // Capture the initial width of the sidebar before fixing it
    const sidebarInitialWidth = sidebar.offsetWidth;

    // Get the navigation bar height
    const navbarHeight = document.querySelector('nav').offsetHeight;

    // Calculate the top position of the sidebar
    const sidebarTop = sidebar.getBoundingClientRect().top + window.scrollY - navbarHeight;

    // Get the services details area container
    const servicesDetailsArea = document.querySelector('.services-details-area');

    // Calculate the bottom position of the services details area
    const servicesDetailsAreaBottom = servicesDetailsArea.getBoundingClientRect().bottom + window.scrollY - sidebar.offsetHeight - 90; // Adjust 210 to stop earlier

    // Add padding to the top of the sidebar equal to the height of the navigation bar
    sidebar.style.paddingTop = `${navbarHeight}px`;

    // Add scroll event listener to window
    window.addEventListener('scroll', () => {
        // Calculate the scroll distance from top
        const scrollTop = window.scrollY;

        // Check if the scroll distance is greater than or equal to the top position of the sidebar
        // and less than the position of the bottom of the services details area
        if (scrollTop >= sidebarTop && scrollTop <= servicesDetailsAreaBottom) {
            // Fix the position of the sidebar
            sidebar.style.position = 'fixed';
            sidebar.style.top = `${navbarHeight}px`; // Adjust for the height of the navigation bar
            sidebar.style.width = `${sidebarInitialWidth}px`; // Keep the sidebar width consistent
        } else {
            // Release the fixed position of the sidebar
            sidebar.style.position = 'static';
            sidebar.style.width = ''; // Reset the width when not fixed
        }
    });
}

};
</script>
